import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { OrderDetail } from "@/features/my/orders/detail";
import { maskSearchFragment } from "@/features/shared/route-masking";

const querySchema = z.object({
  // A link to one message in the order thread — the office's own key, so an office
  // link that redirects here keeps working.
  "message-id": z.string().optional(),
  // A link to one of the order's visits (Birdie's chat links a visit this way): the page shows that visit.
  visitId: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute(
  "/(member)/(protected)/my/orders/$orderId",
)({
  component: OrderDetail,
  validateSearch: querySchema,
});
